import { AsyncLoadedArray } from "@/lib/asyncLoaded"

export async function loadArrayToState<T>(
    getFn: () => Promise<T[]>,
    setState: React.Dispatch<React.SetStateAction<AsyncLoadedArray<T>>>
) {
    setState(previous => previous.withLoading())
    try {
        const data = await getFn()
        setState(previous => previous.withSucceeded(data))
    } catch (error) {
        setState(previous => previous.withFailed(JSON.stringify(error)))
    }
}